import React, { useEffect, useState } from 'react'
import './DraggableListSorting.scss'
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons'
import { Input, Select, Button, Modal, Spin } from 'antd'
import EmptyComponent from '../../../../components/EmptyComponent/EmptyComponent'
import { mixGetV2, mixPostV2 } from '../../../../services/mixin'
import CreateSystemParamModal from '../../../../components/SyncData/CreateSystemParamModalV2'
import useToast from '../../../../hook/useToast';
import * as XLSX from "xlsx";
import { text } from 'stream/consumers'
import { set } from 'lodash'
interface Props {
  items: any
  onChange: (items: any) => void
  onChangex?: (data: any, type: any) => void
  defaultSelectedItems?: any
  sourceId?: any
  source?: any
  idsNotReady?: any
  paramMap?: any
  show?: boolean
}
const dragIcon = <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M7.5 5C7.5 5.39782 7.65804 5.77936 7.93934 6.06066C8.22064 6.34196 8.60218 6.5 9 6.5C9.39782 6.5 9.77936 6.34196 10.0607 6.06066C10.342 5.77936 10.5 5.39782 10.5 5C10.5 4.60218 10.342 4.22064 10.0607 3.93934C9.77936 3.65804 9.39782 3.5 9 3.5C8.60218 3.5 8.22064 3.65804 7.93934 3.93934C7.65804 4.22064 7.5 4.60218 7.5 5Z" fill="currentColor" /> <path d="M14.5 5C14.5 5.39782 14.658 5.77936 14.9393 6.06066C15.2206 6.34196 15.6022 6.5 16 6.5C16.3978 6.5 16.7794 6.34196 17.0607 6.06066C17.342 5.77936 17.5 5.39782 17.5 5C17.5 4.60218 17.342 4.22064 17.0607 3.93934C16.7794 3.65804 16.3978 3.5 16 3.5C15.6022 3.5 15.2206 3.65804 14.9393 3.93934C14.658 4.22064 14.5 4.60218 14.5 5Z" fill="currentColor" /> <path d="M7.5 12.5C7.5 12.8978 7.65804 13.2794 7.93934 13.5607C8.22064 13.842 8.60218 14 9 14C9.39782 14 9.77936 13.842 10.0607 13.5607C10.342 13.2794 10.5 12.8978 10.5 12.5C10.5 12.1022 10.342 11.7206 10.0607 11.4393C9.77936 11.158 9.39782 11 9 11C8.60218 11 8.22064 11.158 7.93934 11.4393C7.65804 11.7206 7.5 12.1022 7.5 12.5Z" fill="currentColor" /> <path d="M14.5 12.5C14.5 12.8978 14.658 13.2794 14.9393 13.5607C15.2206 13.842 15.6022 14 16 14C16.3978 14 16.7794 13.842 17.0607 13.5607C17.342 13.2794 17.5 12.8978 17.5 12.5C17.5 12.1022 17.342 11.7206 17.0607 11.4393C16.7794 11.158 16.3978 11 16 11C15.6022 11 15.2206 11.158 14.9393 11.4393C14.658 11.7206 14.5 12.1022 14.5 12.5Z" fill="currentColor" /> <path d="M7.5 20C7.5 20.3978 7.65804 20.7794 7.93934 21.0607C8.22064 21.342 8.60218 21.5 9 21.5C9.39782 21.5 9.77936 21.342 10.0607 21.0607C10.342 20.7794 10.5 20.3978 10.5 20C10.5 19.6022 10.342 19.2206 10.0607 18.9393C9.77936 18.658 9.39782 18.5 9 18.5C8.60218 18.5 8.22064 18.658 7.93934 18.9393C7.65804 19.2206 7.5 19.6022 7.5 20Z" fill="currentColor" /> <path d="M14.5 20C14.5 20.3978 14.658 20.7794 14.9393 21.0607C15.2206 21.342 15.6022 21.5 16 21.5C16.3978 21.5 16.7794 21.342 17.0607 21.0607C17.342 20.7794 17.5 20.3978 17.5 20C17.5 19.6022 17.342 19.2206 17.0607 18.9393C16.7794 18.658 16.3978 18.5 16 18.5C15.6022 18.5 15.2206 18.658 14.9393 18.9393C14.658 19.2206 14.5 19.6022 14.5 20Z" fill="currentColor" /> </svg>

const DraggableListSorting: React.FC<Props> = (props) => {
  const { items, onChange, defaultSelectedItems, sourceId, source, idsNotReady, paramMap, onChangex, show } = props
  const pushToast = useToast();
  const [curentSourceId, setCurentSourceId] = useState(sourceId || null)
  const [sourceItems, setSourceItems] = useState<any>([])
  const [selectedItems, setSelectedItems] = useState<any>([])
  const [draggedItem, setDraggedItem] = useState<any>({})
  const [isSourceItemDragged, setIsSourceItemDragged] = useState(false)
  const [showParamModal, setShowParamModal] = useState(false)
  const [loading, setLoading] = useState(false)
  const [showModal, setShowModal] = useState(false)
  const [showModalError, setShowModalError] = useState(false)
  const [errExList, setErrExList] = useState([] as any)
  const [paramKeys, setParamKeys] = useState([] as any)

  useEffect(() => {
    if (items.length === 0) {
      setSelectedItems([])
    }
  }, [items])
  useEffect(() => {
    if (defaultSelectedItems && paramKeys.length > 0 && (selectedItems.length === 0 || sourceId !== curentSourceId)) {
      const temp = [] as any
      defaultSelectedItems.map((val: any) => {
        let found = null
        if(sourceId) {
          found = paramKeys.find((x: any) =>  x.json && x.json.includes(`"${val.text}"`) && x.source_id.includes(sourceId));
        } else {
          found = paramKeys.find((x: any) =>  x.json && x.json.includes(`"${val.text}"`));
        }

        if (found) {
          temp.push({ ...val, code: found.column })
        } else {
          temp.push({ ...val, code: null })
        }
      })
      setCurentSourceId(sourceId)
      setSelectedItems([...temp])
      onChange([...temp])
    }
  }, [defaultSelectedItems, paramKeys, selectedItems, sourceId])

  // ON SELECTED ITEMS DRAG START
  const onSelectedItemsDragStart = (e: any, index: number) => {
    setDraggedItem(selectedItems[index])
    e.dataTransfer.effectAllowed = "move"
    e.dataTransfer.setData("text/html", e.target.parentNode)
    e.dataTransfer.setDragImage(e.target.parentNode, 20, 20)
  }

  // ON SELECTED ITEMS DRAG OVER
  const onSelectedItemsDragOver = (index: number) => {
    const draggedOverItem = selectedItems[index]

    // if the item is dragged over itself, ignore
    if (draggedItem === draggedOverItem) {
      return
    }

    // filter out the currently dragged item
    let otherItems = selectedItems.filter((item: any) => item !== draggedItem)

    // add the dragged item after the dragged over item
    otherItems.splice(index, 0, draggedItem)

    if (isSourceItemDragged) {
      const { id } = draggedItem
      const newSourceItems = sourceItems.filter((item: any) => item.id !== id)
      setSourceItems(newSourceItems)
    }

    setSelectedItems(otherItems)
    onListChange(otherItems)
  }

  // ON SELECTED ITEMS DRAG END
  const onSelectedItemsDragEnd = () => {
    setDraggedItem({})
  }

  // ON REMOVE SELECTED ITEM
  const removeSelectedItem = (item: any) => {
    const { id } = item
    const newSelectedItems = selectedItems.filter((item: any) => item.id !== id)
    setSelectedItems(newSelectedItems)
    if (sourceItems.length > 0) {
      setSourceItems([
        ...sourceItems,
        item,
      ])
    }
    onChange(newSelectedItems)
  }

  // ALLOW DROP
  const allowDrop = (e: any) => {
    e.preventDefault()
  }

  // ON DROP
  const onDrop = (e: any) => {
    setIsSourceItemDragged(false)
    e.preventDefault()
    const { id } = draggedItem
    const newSourceItems = sourceItems.filter((item: any) => item.id !== id)

    if (selectedItems.length === 0) {
      setSelectedItems([draggedItem])
      setSourceItems(newSourceItems)
      onListChange([draggedItem])
    } else {
      const isExistInSelectedItems = selectedItems.find((item: any) => item.id === id)

      if (!isExistInSelectedItems) {
        const oldSelectedItems = selectedItems
        oldSelectedItems.push(draggedItem)
        setSelectedItems(oldSelectedItems)
        setSourceItems(newSourceItems)
        onListChange(oldSelectedItems)
      }
    }
  }

  // ON SOURCE ITEM DRAGGED
  const onSourceItemDragged = (e: any, index: number) => {
    setDraggedItem(sourceItems[index])
    setIsSourceItemDragged(true)
    e.dataTransfer.effectAllowed = "move"
    e.dataTransfer.setData("text/html", e.target)
    e.dataTransfer.setDragImage(e.target, 20, 20)
  }

  const onListChange = (items: any) => {
    onChange(items)
  }

  let wait3 = false
  const getParamKeys = async (alert = false) => {
    if (wait3) {
      return
    }
    wait3 = true
    const res = await mixGetV2('/api/v1/be/source_column_warehouses?is_active=1&category_source_group_id=3')
    wait3 = false
    if (res.status) {
      const temp = [] as any
      res.data.items.map((val: any) => {
        const listSourceIds = [] as any
        val.params_key.map((val: any) => {
          listSourceIds.push(val.source_id)
          return true
        })
        temp.push({ id: val.id, json: val.json, name: val.name, column: val.column_warehouse.column, source_id: listSourceIds })
        return true
      })
      if (alert) {
        pushToast('Param hệ thống đã được làm mới', "success");
      }
      setParamKeys([...temp])
      // fix selectedItems
      const newSelectedItems = selectedItems.map((item: any) => {
        const found = temp.find((x: any) => x.json && x.json.includes(`"${item.text}"`));
        if (found) {
          return { ...item, code: found.column }
        }
        return item
      })
      setSelectedItems(newSelectedItems)
      onChange(newSelectedItems)
      setLoading(false)
    }
  }
  useEffect(() => {
    getParamKeys()
  }, [])

  const randomStr = () => {
    return Math.random().toString(36).substring(2, 10);
  }

  const [changeData, setChangeData] = useState({} as any)
  const changeParamCode = async (value: any, index: number, item: any) => {
    const data = [] as any
    const findParamkey = paramKeys.find((x: any) => x.json && x.json.includes(`"${item.text}"`))
    const findData = paramKeys.find((x: any) => x.column === value)
    if (!findParamkey) {
      const json = JSON.parse(findData?.json || '[]')
      data.push({
        id: findData.id,
        json: JSON.stringify([...json, item.text]),
      })
      setLoading(true)
      const res = await mixPostV2('/api/v1/be/multi_source_column_warehouse', {
        data: JSON.stringify(data),
      })
      if (res.status) {
        getParamKeys()
      }
    } else {
      const oldJson = JSON.parse(findParamkey?.json || '[]')
      const newJson = JSON.parse(findData?.json || '[]')
      const filteredOldJson = oldJson.filter((x: any) => x !== item.text)
      newJson.push(item.text)
      data.push({
        id: findParamkey.id,
        json: JSON.stringify(filteredOldJson),
      })
      data.push({
        id: findData.id,
        json: JSON.stringify(newJson),
      })
      const temp = {
        data: JSON.stringify(data),
        text: item.text,
        old_column: findParamkey.column,
        old_column_label: findParamkey.name,
        new_column: findData.column,
        new_column_label: findData.name,
      }
      setChangeData(temp)
      setShowModal(true)
    }
    return true
    const newSelectedItems = [...selectedItems]
    newSelectedItems[index] = { ...item, code: value }
    setSelectedItems(newSelectedItems)
    onChange(newSelectedItems)
  }

  const changeJson = async () => {
    setLoading(true)
    const res = await mixPostV2('/api/v1/be/multi_source_column_warehouse', {
      data: changeData.data,
    })
    if (res.status) {
      setShowModal(false)
      getParamKeys()
    }
  }

  return (
    <>
      <div className='head-box-template-management'>
        <div className='left-box'>
          <Button
            type="primary"
            className="rs-button primary-outline"
            onClick={() => {
              getParamKeys(true)
            }}
          >Làm mới</Button>
          <Button
            className="rs-button primary-outline"
            icon={<PlusOutlined />}
            onClick={() => {
              const newItem = {
                id: randomStr(),
                text: '',
                code: null
              }
              const newSelectedItems = [...selectedItems, newItem]
              setSelectedItems(newSelectedItems)
              onChange(newSelectedItems)
            }}
          >
            Thêm dòng
          </Button>
          <Button
            icon={<PlusOutlined />}
            type="primary"
            className="rs-button primary-outline"
            onClick={() => {
              setShowParamModal(true)
            }}
          >Tạo param mới</Button>
        </div>

        <div className='right-box'>
          <Button
            className="rs-button primary-outline"
            onClick={() => {
              const input = document.createElement('input');
              input.type = 'file';
              input.accept = '.xlsx,.xls';
              input.onchange = async (e: any) => {
                const file = e.target.files[0];
                if (!file) return;
                const reader = new FileReader();
                reader.onload = (evt: any) => {
                  const data = evt.target.result;
                  const workbook = XLSX.read(data, {
                    type: 'binary',
                    sheetRows: 1  // Chỉ đọc 1 dòng đầu tiên
                  });
                  const sheetName = workbook.SheetNames[0];
                  const sheet = workbook.Sheets[sheetName];
                  const json = XLSX.utils.sheet_to_json(sheet, { header: 1 });
                  const headerRow = Array.isArray(json[0]) ? json[0] : [];
                  const uniqueHeaders = Array.from(new Set(headerRow.filter((col: any) => !!col)));
                  const newItems = [] as any
                  const errList = [] as any
                  uniqueHeaders.map((col: any, idx: any) => {
                    const pr = paramKeys.find((x: any) => x.json && x.json.includes(`"${col}"`))
                    if (pr) {
                      const findData = newItems.find((x: any) => pr.column && x.code === pr.column)
                      if (findData) {
                        errList.push({
                          findData: findData,
                          pr: pr,
                          col: col,
                        })
                      }
                      newItems.push({
                        id: randomStr() + idx,
                        text: col,
                        code: findData ? null : pr.column || null
                      })
                    } else {
                      newItems.push({
                        id: randomStr() + idx,
                        text: col,
                        code: null
                      })
                    }

                    return true
                  })
                  if (errList.length > 0) {
                    setErrExList(errList);
                    setShowModalError(true);
                    return;
                  }
                  setSelectedItems(newItems);
                  onChange(newItems);
                };
                reader.readAsBinaryString(file);
              };
              input.click();
            }}
          >
            Tải lên file Excel
          </Button>
        </div>
      </div>
      <Spin spinning={loading}>

        <div className="draggable-list-wrapper">
          <div className="draggable-list-sorting">
            <div className="draggable-list-sorting__head">
              <div className="draggable-list-sorting__item">
                <div className="item fsz-16 neutral-gray-700">Dữ liệu trong tệp nhập liệu</div>
                <div className="item fsz-16 neutral-gray-700">Giá trị</div>
              </div>
            </div>
            <div
              className="draggable-list-sorting__body"
              onDragOver={allowDrop}
              onDrop={onDrop}
            >
              {
                selectedItems.length > 0
                  ? selectedItems.map((item: any, index: number) => (
                    <div
                      key={index}
                      className={`draggable-list-sorting__item ${idsNotReady.includes(item.id) ? 'danger-draggable-item' : 'ready'}`}
                      onDragOver={() => onSelectedItemsDragOver(index)}
                    >
                      <div className="item">
                        <span
                          className="icon"
                          draggable
                          onDragStart={(e: any) => onSelectedItemsDragStart(e, index)}
                          onDragEnd={onSelectedItemsDragEnd}
                        >{dragIcon}</span>
                        <span className='text'>
                          <Input
                            value={item.text}
                            onChange={e => {
                              const newSelectedItems = [...selectedItems]
                              newSelectedItems[index] = { ...item, text: e.target.value }
                              const found = paramMap.find((x: any) => x.data.includes(e.target.value));
                              if (found) {
                                newSelectedItems[index] = { ...item, text: e.target.value, code: found.column };
                              }
                              setSelectedItems(newSelectedItems)
                              onChange(newSelectedItems)
                            }}
                            placeholder="Nhập giá trị..."
                            className="rs-input rs-input--32"
                          />
                        </span>
                      </div>
                      <div className="item content-between">
                        <Select
                          value={item.code}
                          onChange={value => {
                            changeParamCode(value, index, item)
                          }}
                          placeholder="Chọn giá trị..."
                          className="rs-select"

                          optionFilterProp="children"
                          showSearch
                          filterOption={(input, option) => {
                            const label = option?.children?.toString().toLowerCase() || '';
                            const valueStr = option?.value?.toString().toLowerCase() || '';
                            const inputStr = input.toLowerCase();
                            // match accent-insensitive and space-insensitive
                            const normalize = (str: string) =>
                              str
                                .normalize('NFD')
                                .replace(/[\u0300-\u036f]/g, '')
                                .replace(/\s/g, '');
                            return (
                              normalize(label).includes(normalize(inputStr)) ||
                              normalize(valueStr).includes(normalize(inputStr))
                            );
                          }}
                        >
                          {paramKeys
                            .filter((param: any) =>
                              (!sourceId || param.source_id.includes(sourceId)) &&
                              !selectedItems.some(
                                (selected: any, idx: number) =>
                                  selected.code === param.column && idx !== index
                              )
                            )
                            .map((param: any) => (
                              <Select.Option key={param.column} value={param.column}>
                                {param.name}
                              </Select.Option>
                            ))}
                        </Select>
                        <DeleteOutlined className={`${idsNotReady.includes(item.id) ? 'dust-red-6' : 'ready'}`} onClick={() => removeSelectedItem(item)} />
                      </div>
                    </div>
                  ))
                  : <EmptyComponent />
              }
            </div>
          </div>
        </div>

      </Spin>

      <CreateSystemParamModal
        show={showParamModal}
        source={source}
        sourceId={sourceId}
        hideStatus={true}
        modalClose={() => setShowParamModal(false)}
        onSubmitted={() => {
          setShowParamModal(false)
          getParamKeys()
        }}
      />

      <Modal
        open={showModal}
        title='Xác nhận thay giá trị'
        className='rs-modal w-520 import-data-template-modal footer-content-end'
        maskClosable={false}
        keyboard={false}
        centered
        footer={() => (
          <>
            <Button
              className="rs-button"
              onClick={() => setShowModal(false)}
            >Hủy</Button>
            <Button
              type="primary"
              loading={loading}
              className="rs-button"
              onClick={() => changeJson()}
            >Xác nhận thay đổi</Button>
          </>
        )}
        onCancel={() => setShowModal(false)}
      >
        <div className='fsz-16 fw-500 mb-3'>Bạn có chắc chắn muốn thay đổi giá trị mới?</div>
        <div className='fsz-14 neutral-gray-700'>
          <div>Dữ liệu trong tệp nhập liệu: <b>{changeData.text}</b></div>
          <div>Giá trị cũ: <b>{changeData.old_column_label}</b></div>
          <div>Giá trị mới: <b>{changeData.new_column_label}</b></div>
        </div>
      </Modal>

      <Modal
        open={showModalError}
        title='Lỗi trùng giá trị'
        className='rs-modal w-520 import-data-template-modal footer-content-end'
        maskClosable={false}
        keyboard={false}
        centered
        footer={() => (
          <>
            <Button
              className="rs-button"
              onClick={() => setShowModalError(false)}
            >Đóng</Button>
          </>
        )}
        onCancel={() => setShowModalError(false)}
      >
        <div className='fsz-16 fw-500 mb-3'>Có giá trị bị trùng trong file Excel. Vui lòng kiểm tra lại!</div>
        <div className='fsz-14 neutral-gray-700'>
          {errExList.map((item: any, index: number) => (
            <div key={index}>- <b>{item.findData.text}</b> và <b>{item.col}</b> trùng giá trị <b>{item.pr.name}</b></div>
          ))}
        </div>
      </Modal>
    </>
  )
}

export default DraggableListSorting
